import Config from './organization-alert-config.router';
import options from './organization-alert-config.component';
import fileChangeDirective from './file-change.directive';
import dragDropDirective from './drag-drop.directive';
import contactGroupsModule from './contact-groups';
import alertTemplatesModule from './alert-templates';
import escalationsModule from './escalations';
import escalationBuilderModule from './escalation-builder';
import thresholdBuilderModule from './threshold-builder';

const Component = {
    selector: 'dtOrganizationAlertConfigPage',
    options
};

const FileChangeDirective = {
    selector: 'fileChange',
    options: fileChangeDirective
};

const DragDropDirective = {
    selector: 'dragDrop',
    options: dragDropDirective
};

export {
    Config,
    Component,
    FileChangeDirective,
    DragDropDirective,
    contactGroupsModule,
    alertTemplatesModule,
    escalationsModule,
    escalationBuilderModule,
    thresholdBuilderModule
}; 